import React, {useEffect, useState} from "react";
import {apichkPointsLogsData, apiReqEnumsNames, chkPointsLogs} from "../utils/API";

import {
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    TablePagination,
    Box, Typography, Checkbox,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close'; // Add this at the top
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DataObjectIcon from '@mui/icons-material/DataObject';
import RefreshIcon from '@mui/icons-material/Refresh';
import {IconButton,CircularProgress,Tooltip,Snackbar,TextField,InputAdornment} from '@mui/material';
import ReactJson from "react-json-view";
import Header from "../components/core/Header";
import {theme} from "../config/MuiTheme";
import Moment from "moment/moment";
import DateFilter from "../components/core/DateFilter";
import moment from "moment/moment";
import SelectComponent from "../components/core/SelectComponent";
import InputComponent from "../components/core/InputComponent";
import SearchIcon from "@mui/icons-material/Search"; // Optional: use --legacy-peer-deps if needed
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

export const ChkPointLogs = () => {
        const [loading, setLoading] = useState(false);const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [logs, setLogs] = useState([]);
    const [logsData, setLogsData] = useState('');
    const [selectedLog, setSelectedLog] = useState(null);
    const [servername, setServername] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [msgdialogOpen, setMsgDialogOpen] = useState(false);
    const [startDate, setStartDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [claimnotype, setClaimNoType] = useState(null);
    const [showHistory, setShowHistory] = useState(true);
    const [claimno, setClaimNo] = useState(null);
    const [dateSelected, setDateSelected] = useState({
        fromDate: Moment(new Date()).format("YYYY-MM-DD"),
        toDate: Moment(new Date()).format("YYYY-MM-DD"),
    });

    const [requestTypes, setRequestTypes] = useState([]);
    const [selectedType, setSelectedType] = useState('');
    const [copyStatus, setCopyStatus] = useState('');
    const [jsonSearch, setJsonSearch] = useState('');
    const [jsonParsed, setJsonParsed] = useState(false);

    function getHeaderColor(type = '') {
        switch (type.toUpperCase()) {
            case 'INFO':
                return '#508293'; // light cyan
            case 'WARNING':
                return '#dc4a30'; // light orange
            case 'EXCEPTION':
                return '#c62f2f'; // light red
            case 'ERROR':
                return '#151E3D'; // light blue
            case 'SUCCESS':
                    return '#008000'; // light blue
            case 'FAILURE':
                return '#FF0000'; // light red
            default:
                return '#954444'; // default gray
        }
    }


    function formatMessageText(text = '') {
        return text
            // .replace(/(Token value:)/g, '\n$1')
            // .replace(/(build:)/g, '\n$1')
            .replace(/, /g, ',\n')
            .replace(/\(/g, '(\n')
            .replace(/\)/g, '\n)');
    }

    useEffect(() => {
        const getReqApiTypesEnums = async () => {
            try {
                const response = await apiReqEnumsNames();  // Your API call

                if (response?.success && Array.isArray(response.data)) {
                    const formattedData = response.data.map((type) => ({
                        id: type,
                        name: type
                            .replace(/_REQUEST$/, "")               // remove "_REQUEST"
                            .replace(/_/g, " ")                     // replace underscores with spaces
                            .toLowerCase()
                            .replace(/\b\w/g, (c) => c.toUpperCase()) // capitalize each word
                    }));

                    // Prepend default option
                    const withDefault = [
                        { id: "Select Request Type", name: "Select Request Type" },
                        ...formattedData
                    ];

                    setRequestTypes(withDefault)
                }
            } catch (error) {
                console.error("Error fetching request types", error);
            }
        };

        getReqApiTypesEnums();
    }, []);


    function calculateTAT(totalMillis) {
        const hours = Math.floor(totalMillis / (1000 * 60 * 60));
        const minutes = Math.floor((totalMillis / (1000 * 60)) % 60);
        const seconds = Math.floor((totalMillis / 1000) % 60);
        const milliseconds = totalMillis % 1000;

        return `${hours}h ${minutes}m ${seconds}s ${milliseconds}ms`;
    }

    function formatLabel(input) {
        return input
            .replace(/_/g, ' ')           // Replace underscores with spaces
            .replace(/\bREQUEST\b/g, '')  // Remove the word 'REQUEST' as a whole word
            .replace(/\s+/g, ' ')         // Replace multiple spaces with one
            .trim();                      // Remove leading/trailing spaces
    }

    // blank intimateNumber is accepted; a non-blank one must match the searched intimation number or claim id
    const isIntimateNumberMatched = (log) => {
        const normalize = (value) => String(value ?? '').trim().toLowerCase();
        const intimateNumber = normalize(log.intimateNumber);
        const intimationNumber = normalize(log.intimationNumber);
        const claimId = normalize(log.claimId);

        if (!intimateNumber || (!intimationNumber && !claimId)) return true;
        return intimateNumber === intimationNumber || intimateNumber === claimId;
    };

    /* useEffect(() => { */
    const fetchLogs = async () => {
        try {
            setLoading(true);

            const response = await chkPointsLogs(servername, selectedType, claimnotype, claimno, startDate, endDate, showHistory);
            if (response?.success && Array.isArray(response.data)) {
                // Step 0: add id field
                const dataWithId = response.data
                    .map((item, index) => ({ id: item.id || index, ...item }))
                    .filter(isIntimateNumberMatched);

                // Step 1: get unique transaction IDs in order of first appearance
                const order = [...new Set(dataWithId.map(item => item.transactionID))];

                // Step 2: group items by transactionId in order
                const sortedList = [];
                order.forEach(transactionId => {
                    dataWithId
                        .filter(item => item.transactionID === transactionId)
                        .forEach(item => sortedList.push(item));
                });

                // Step 3: set state once
                setLogs(sortedList);
            } else {
                setLogs([]);
            }

            setPage(0);
        } catch (error) {
            console.error("Error fetching logs", error);
        } finally {
            setLoading(false);
        }
    };

    /*   fetchLogs(); */
    /*}, []); */


    const handleSearchInput = (e) => {
        setClaimNo(e.target.value);
    };
    const handleOpenDialog = async (id) => {
        // every log opens on its original JSON, with the search box cleared
        setJsonSearch('');
        setJsonParsed(false);

        try {


            const response = await apichkPointsLogsData(id);
            if (response?.success) {
                setLogsData(response.data);
            }else{
                setLogsData('');
            }

        } catch (error) {
            console.error("Error fetching logs", error);
        }
        setDialogOpen(true);
    };

    const handleMsgOpenDialog = (log) => {
        setSelectedLog(log);
        setMsgDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setLogsData('');
        setJsonSearch('');
        setJsonParsed(false);
        setSelectedLog(null);
        setDialogOpen(false);
        setMsgDialogOpen(false);
    };
    const handleDateChange = (date, field) => {
        const fromDate = moment(dateSelected.fromDate, "YYYY-MM-DD");
        const toDate = moment(dateSelected.toDate, "YYYY-MM-DD");

        if (toDate.isBefore(fromDate)) {
            alert('The "toDate" is before the "fromDate"');
        }

        const formattedDate = Moment(date).format("YYYY-MM-DD");

        if (field === "fromDate") {
            setStartDate(formattedDate);
            setDateSelected({...dateSelected, fromDate: formattedDate});
        }

        if (field === "toDate") {
            setEndDate(formattedDate);
            setDateSelected({...dateSelected, toDate: formattedDate});

        }
    };


    const menuList = [
        {
            displayName: "All",
            id: "ALL",
        },
        {
            displayName: "Genesis",
            id: "Genesis",
        }

    ];
    const ClaimNoTypemenuList = [
        {
            displayName: "Claim ID",
            id: "claim_id",
        },
        {
            displayName: "Claim Intimation No",
            id: "intimation",
        }

    ];
    const groupedLogs = React.useMemo(() => {
        const reversed = [...logs].reverse(); // latest logs first
        const map = new Map();

        reversed.forEach(log => {
            if (!map.has(log.transactionID)) {
                map.set(log.transactionID, []);
            }
            map.get(log.transactionID).push(log);
        });

        return Array.from(map.entries());
        // [ [transactionID, logs[]], ... ]
    }, [logs]);
    const transactionWiseLogs = React.useMemo(() => {
        return groupedLogs.map(([transactionID, txnLogs]) => ({
            transactionID,
            logs: [...txnLogs].reverse() // reverse inside transaction
        }));
    }, [groupedLogs]);

    const flattenedLogs = React.useMemo(() => {
        return transactionWiseLogs.flatMap(txn => txn.logs);
    }, [transactionWiseLogs]);

    // claim status per transaction (first log of the transaction that carries one)
    const claimStatusByTransaction = React.useMemo(() => {
        const map = new Map();
        transactionWiseLogs.forEach(({transactionID, logs: txnLogs}) => {
            const logWithStatus = txnLogs.find(log => log.claimStatus);
            map.set(transactionID, logWithStatus?.claimStatus || '');
        });
        return map;
    }, [transactionWiseLogs]);

    const paginatedLogs = React.useMemo(() => {
        return flattenedLogs.slice(
            page * rowsPerPage,
            page * rowsPerPage + rowsPerPage
        );
    }, [flattenedLogs, page, rowsPerPage]);







    const formatToIST = (value) => {
        if (!value) return value;

        const date = new Date(value);
        if (isNaN(date.getTime())) return value;

        const pad = (n, z = 2) => String(n).padStart(z, "0");

        // Use Intl with Asia/Kolkata timezone
        const parts = new Intl.DateTimeFormat("en-GB", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            fractionalSecondDigits: 3,
            hour12: false,
        }).formatToParts(date);

        const get = (type) => parts.find(p => p.type === type)?.value;

        return (
            `${get("year")}-${get("month")}-${get("day")} ` +
            `${get("hour")}:${get("minute")}:${get("second")}.${get("fractionalSecond")}`
        );
    };





    /* Splits "a=1, b={x=2, y=3}, c=[1, 2]" on top level commas only.
       Brace / bracket / double quote aware, so nested JSON stays in one piece. */
    const splitTopLevel = (text) => {
        const parts = [];
        let depth = 0;
        let inString = false;
        let backslashes = 0;
        let current = "";

        for (const ch of text) {
            const escaped = backslashes % 2 === 1;
            backslashes = ch === "\\" ? backslashes + 1 : 0;

            if (ch === '"' && !escaped) {
                // escaped quotes (\") belong to an embedded JSON payload, not to a real string
                inString = !inString;
            } else if (!inString) {
                if (ch === "{" || ch === "[") depth++;
                else if (ch === "}" || ch === "]") depth--;
                else if (ch === "," && depth === 0) {
                    parts.push(current);
                    current = "";
                    continue;
                }
            }

            current += ch;
        }

        parts.push(current);
        return parts;
    };

    /* Undoes one level of backslash escaping ( \" \n \t ... ) */
    const unescapeOnce = (text) => {
        const map = {'"': '"', "\\": "\\", "/": "/", b: "\b", f: "\f", n: "\n", r: "\r", t: "\t"};
        return text.replace(/\\(["\\/bfnrt])/g, (match, ch) => map[ch]);
    };

    /* Java map / list toString values ("{a=1, b=x}") are not JSON — rebuild them as objects */
    const parseJavaValue = (raw) => {
        const text = raw.trim();

        if (text === "") return "";
        if (text === "true") return true;
        if (text === "false") return false;
        if (text === "null") return null;
        // only treat as a number when it round trips (keeps leading zeros / ids as strings)
        if (/^-?\d+(\.\d+)?$/.test(text) && String(Number(text)) === text) return Number(text);

        return parseJsonDeep(text);
    };

    const parseJavaMapString = (text) => {
        const body = text.trim().slice(1, -1).trim();
        if (body === "") return {};

        const result = {};

        for (const entry of splitTopLevel(body)) {
            const separator = entry.indexOf("=");
            if (separator === -1) return null;               // not a key=value map, keep raw text

            const key = entry.slice(0, separator).trim();
            if (!key || /[{}[\]"]/.test(key)) return null;   // key looks like data, keep raw text

            result[key] = parseJavaValue(entry.slice(separator + 1));
        }

        return result;
    };

    const parseJavaListString = (text) => {
        const body = text.trim().slice(1, -1).trim();
        if (body === "") return [];

        return splitTopLevel(body).map((item) => parseJavaValue(item));
    };

    /* Turns stringified JSON values ("{\"a\":1}") and Java toString values
       ("{a=1, b=2}") into real objects/arrays so the viewer shows proper JSON
       instead of one long escaped string. */
    const parseJsonDeep = (value, unwrapDepth = 0) => {
        if (typeof value === "string") {
            if (unwrapDepth >= 8) return value;

            let trimmed = value.trim();

            // values sometimes arrive wrapped in extra pairs of quotes: ""{...}""
            while (trimmed.length > 1 && trimmed.startsWith('"') && trimmed.endsWith('"')) {
                trimmed = trimmed.slice(1, -1).trim();
            }

            const isObjectLike = trimmed.startsWith("{") && trimmed.endsWith("}");
            const isArrayLike = trimmed.startsWith("[") && trimmed.endsWith("]");
            if (!isObjectLike && !isArrayLike) return value;

            try {
                return parseJsonDeep(JSON.parse(trimmed), unwrapDepth + 1);
            } catch (e) {
                // not JSON yet — payloads often arrive double escaped ( \" and \n as literal chars )
                if (/\\["\\/bfnrt]/.test(trimmed)) {
                    return parseJsonDeep(unescapeOnce(trimmed), unwrapDepth + 1);
                }
            }

            try {
                const parsed = isObjectLike
                    ? parseJavaMapString(trimmed)
                    : parseJavaListString(trimmed);

                return parsed === null ? value : parsed;
            } catch (error) {
                return value;
            }
        }

        if (Array.isArray(value)) return value.map((item) => parseJsonDeep(item));

        if (value && typeof value === "object") {
            return Object.fromEntries(
                Object.entries(value).map(([key, val]) => [key, parseJsonDeep(val)])
            );
        }

        return value;
    };

    const copyToClipboard = async (text) => {
        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(text);
            } else {
                // Fallback for non-secure (http) contexts where navigator.clipboard is unavailable
                const area = document.createElement("textarea");
                area.value = text;
                area.style.position = "fixed";
                area.style.opacity = "0";
                document.body.appendChild(area);
                area.select();
                document.execCommand("copy");
                document.body.removeChild(area);
            }
            setCopyStatus("JSON copied to clipboard");
        } catch (error) {
            console.error("Copy failed", error);
            setCopyStatus("Copy failed");
        }
    };

    const convertSelectedDates = (data) => {
        if (!data || typeof data !== "object") return data;

        const updated = structuredClone(data);

        if (
            updated.collectionData &&
            typeof updated.collectionData === "object"
        ) {
            // 1️⃣ _id.date
            if (
                updated.collectionData._id &&
                typeof updated.collectionData._id === "object" &&
                updated.collectionData._id.date
            ) {
                updated.collectionData._id.date = formatToIST(
                    updated.collectionData._id.date
                );
            }

            // 2️⃣ collectionData.date_created
            if (updated.collectionData.date_created) {
                updated.collectionData.date_created = formatToIST(
                    updated.collectionData.date_created
                );
            }

            // 3️⃣ collectionData.date_updated
            if (updated.collectionData.date_updated) {
                updated.collectionData.date_updated = formatToIST(
                    updated.collectionData.date_updated
                );
            }
            // 2️⃣ collectionData.create_date
            if (updated.collectionData.create_date) {
                updated.collectionData.create_date = formatToIST(
                    updated.collectionData.create_date
                );
            }

            // 3️⃣ collectionData.update_date
            if (updated.collectionData.update_date) {
                updated.collectionData.update_date = formatToIST(
                    updated.collectionData.update_date
                );
            }
        }

        return updated;
    };

    /* Keeps only the branches whose key or value matches the search term.
       A key match keeps its whole sub tree; returns undefined when nothing matched. */
    const filterJson = (value, term) => {
        const matches = (text) => String(text).toLowerCase().includes(term);

        if (Array.isArray(value)) {
            const kept = value
                .map((item) => filterJson(item, term))
                .filter((item) => item !== undefined);

            return kept.length ? kept : undefined;
        }

        if (value && typeof value === "object") {
            const kept = {};

            Object.entries(value).forEach(([key, val]) => {
                if (matches(key)) {
                    kept[key] = val;
                    return;
                }

                const child = filterJson(val, term);
                if (child !== undefined) kept[key] = child;
            });

            return Object.keys(kept).length ? kept : undefined;
        }

        return matches(value === null ? "null" : value) ? value : undefined;
    };

    /* The dialog opens on the original (beautified) log; Parse JSON expands the
       stringified inner payloads on demand. */
    const baseJson = logsData
        ? convertSelectedDates(jsonParsed ? parseJsonDeep(logsData) : logsData)
        : null;

    const jsonSearchTerm = jsonSearch.trim().toLowerCase();

    /* JSON shown in the View JSON dialog — also what the Copy JSON button copies */
    const viewJson = jsonSearchTerm && baseJson
        ? filterJson(baseJson, jsonSearchTerm)
        : baseJson;

    const noSearchMatch = Boolean(jsonSearchTerm) && Boolean(baseJson) && viewJson === undefined;


    return (
        <Box
            sx={{
                background: theme.palette.background.default,
                minHeight: "100vh",
            }}
        >
            <Header/>


            <Grid container spacing={2} style={{padding: 16}}>
                <Grid item xs={12}>

                    <Grid
                        item
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <Grid item style={{width: "250px", margin: "5px"}}>
                            <SelectComponent
                                label="Select Request Type"
                                menuItem={requestTypes}
                                setSelections={(val) => setSelectedType(val)}  // Store original enum value
                            />
                        </Grid>
                        <Grid item style={{width: "250px", margin: "5px"}}>
                            <SelectComponent
                                menuItem={menuList}
                                label={"Select Server"}
                                setSelections={setServername}

                            />
                        </Grid>
                        <Grid item style={{width: "250px", margin: "5px"}}>
                            <SelectComponent
                                menuItem={ClaimNoTypemenuList}
                                label={"Select Claim No Type"}
                                setSelections={setClaimNoType}

                            />
                        </Grid>

                        <Grid item style={{width: "350px", marginTop: "20px"}}>
                            <InputComponent
                                handleChange={handleSearchInput}
                                icon={<SearchIcon/>}
                                InputComponent="Search"
                                disabled={
                                    !(claimnotype !== null &&
                                        Object.keys(claimnotype).length !== 0)
                                }
                                fullWidth={true}
                            />
                        </Grid>
                        <Grid item style={{width: "200px", marginTop: "20px"}}>
                            <Checkbox
                                checked={showHistory}
                                onChange={(event) => setShowHistory(event.target.checked)}
                                inputProps={{ "aria-label": "controlled" }}
                            />
                            <label>Fetch it's history</label>
                        </Grid>
                        <Grid item>
                            <DateFilter
                                disableFuture={true}
                                fieldId={"fromDate"}
                                selectedDate={dateSelected.fromDate}
                                onDateChange={handleDateChange}
                            />
                        </Grid>

                        <Grid item>
                            <Typography variant="subtitle2" display="inline">
                                To
                            </Typography>

                        </Grid>
                        <Grid item>
                            <DateFilter
                                disableFuture={true}
                                fieldId={"toDate"}
                                selectedDate={dateSelected.toDate}
                                onDateChange={handleDateChange}
                            />
                        </Grid>
                        {loading && (
                            <Box
                                sx={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100vw",
                                    height: "100vh",
                                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 9999,
                                }}
                            >
                                <CircularProgress size={80} />
                            </Box>
                        )}
                        <Grid item>
                            <Button
                                style={{ float: "right" }}
                                variant="contained"
                                color="primary"
                                onClick={fetchLogs}
                                disabled={loading} // disable button while loading
                                sx={{ textAlign: "center", minWidth: 120 }} // optional min-width for consistency
                            >
                                Load
                            </Button>
                        </Grid>
                    </Grid>


                    {/* ✅ Table with fixed height and scroll */}
                    <TableContainer component={Paper} style={{maxHeight: 700, overflowY: "auto"}}>
                        <Table stickyHeader size="medium">
                            <TableHead sx={{bgcolor: '#001f3f'}}>
                                <TableRow>
                                    {[
                                        'Checkpoint',
                                        'Status',
                                        'Type',
                                        'Created At',
                                        'Requested By',
                                        'TAT',
                                        'Message Type',
                                        'Message',
                                        'Actions',
                                    ].map((header) => (
                                        <TableCell
                                            key={header}
                                            sx={{

                                                color: 'white',
                                                backgroundColor: '#2a5db4',
                                            }}
                                        >
                                            {header}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {paginatedLogs.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={9} align="center">
                                            No logs found
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    paginatedLogs.map((log, index) => {
                                        const globalIndex = page * rowsPerPage + index;

                                        const previousLog = flattenedLogs[globalIndex - 1];

                                        const isTransactionChanged =
                                            log.transactionID !== previousLog?.transactionID;


                                        const hasErrorMessage =
                                            Array.isArray(log.message) &&
                                            log.message.some(msg => msg.type === 'ERROR' || msg.type === 'EXCEPTION' );
                                    return (
                                        <React.Fragment key={log.id || index}>

                                            {isTransactionChanged && (
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={9}
                                                        sx={{
                                                            backgroundColor: '#f0f0f0',
                                                            fontWeight: 'bold',
                                                            textAlign: 'center',
                                                            verticalAlign: 'middle',
                                                            padding: '12px 0',
                                                        }}
                                                    >
                                                        Request
                                                        Type: {formatLabel(log.apirequestType || log.checkPointName || 'N/A')} &nbsp; | &nbsp; Transaction
                                                        ID: {log.transactionID} &nbsp; | &nbsp; Claim
                                                        Status: {(claimStatusByTransaction.get(log.transactionID) || log.claimStatus || 'N/A').replace(/_/g, ' ')}
                                                    </TableCell>
                                                </TableRow>
                                            )}

                                            <TableRow
                                                {...((hasErrorMessage) && {
                                                    sx: { backgroundColor: '#FFECC8', },

                                                })}
                                            >

                                            <TableCell>
                                                    {isTransactionChanged && log.checkPointName === 'REQUEST_RECEIVED'
                                                        ? `${formatLabel(log.apirequestType || 'PROCESSED')} ${log.checkPointName.replace(/_/g, ' ')}`
                                                        : log.checkPointName.replace(/_/g, ' ')}
                                                </TableCell>

                                                <TableCell>
                                                    <Typography  component="span"
                                                                         variant="body2"
                                                                         sx={{
                                                                             color: getHeaderColor(log.status),

                                                                         }}>
                                                {log.status}
                                                </Typography></TableCell>
                                                <TableCell>{formatLabel(log.requestType)}</TableCell>
                                                <TableCell>{log.createdAt}</TableCell>
                                                <TableCell>{log.requested_by}</TableCell>
                                                <TableCell>{calculateTAT(log.tat)}</TableCell>

                                                <TableCell>
                                                    {Array.isArray(log.message) ? (
                                                        Array.from(new Set(log.message.map(msg => msg.type))).map((type, idx, arr) => (
                                                            <Typography
                                                                key={idx}
                                                                component="span"
                                                                variant="body2"
                                                                sx={{
                                                                    color: getHeaderColor(type),

                                                                }}
                                                            >
                                                                {type}
                                                                {idx < arr.length - 1 && ', '}
                                                            </Typography>
                                                        ))
                                                    ) : (
                                                        <Typography variant="body2" color="textSecondary">
                                                            No types
                                                        </Typography>
                                                    )}
                                                </TableCell>

                                                <TableCell>
                                                    {Array.isArray(log.message) && log.message.length > 0 && log.message[0]?.text ? (
                                                        <Box display="inline-flex" alignItems="center" gap={0.5}>
                                                            <Typography variant="body2" component="span">
                                                                {log.message[0].text.length > 25
                                                                    ? `${log.message[0].text.slice(0, 25)}...`
                                                                    : log.message[0].text}
                                                            </Typography>

                                                            {(log.message[0].text.length > 25 || log.message.length > 1) && (
                                                                <Button
                                                                    size="small"
                                                                    color="primary"
                                                                    onClick={() => handleMsgOpenDialog(log)}
                                                                    sx={{ minWidth: 'auto', padding: 0, textTransform: 'uppercase' }}
                                                                >
                                                                    more
                                                                </Button>
                                                            )}
                                                        </Box>
                                                    ) : (
                                                        <Typography variant="body2" color="textSecondary">
                                                            No messages
                                                        </Typography>
                                                    )}
                                                </TableCell>


                                                <TableCell>
                                                    <Button variant="outlined" size="small"
                                                            onClick={() => handleOpenDialog(log.id)}>
                                                        View JSON
                                                    </Button>
                                                </TableCell>
                                            </TableRow>

                                        </React.Fragment>
                                    );
                                }))}



                                </TableBody>

                        </Table>

                    </TableContainer>


                    {/* ✅ Pagination Controls */}
                    <TablePagination

                        style={{
                            position: 'relative',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            backgroundColor: 'white',
                            zIndex: 1000,
                        }}
                        rowsPerPageOptions={[5, 10, 25, 50,100]}
                        component="div"
                        count={logs.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={(event, newPage) => setPage(newPage)}
                        onRowsPerPageChange={(event) => {
                            setRowsPerPage(parseInt(event.target.value, 10));
                            setPage(0);
                        }}
                    />
                </Grid>

                {/* ✅ Dialog with react-json-view */}
                <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                    <DialogTitle sx={{m: 0, p: 2}}>
                        {logsData?.checkPointName && (
                            <span>{logsData.checkPointName.replace(/_/g, ' ')} LOG JSON FORMAT</span>
                        )}

                        <IconButton
                            aria-label="close"
                            onClick={handleCloseDialog}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers>
                        {baseJson && (
                            <Box
                                sx={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 2,
                                    backgroundColor: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    pb: 1,
                                }}
                            >
                                <TextField
                                    fullWidth
                                    size="small"
                                    placeholder="Search key or value in JSON..."
                                    value={jsonSearch}
                                    onChange={(e) => setJsonSearch(e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon fontSize="small"/>
                                            </InputAdornment>
                                        ),
                                        endAdornment: jsonSearch ? (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    size="small"
                                                    aria-label="clear search"
                                                    onClick={() => setJsonSearch('')}
                                                >
                                                    <CloseIcon fontSize="small"/>
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null,
                                    }}
                                />

                                <Tooltip
                                    title={jsonParsed
                                        ? "Back to the original JSON"
                                        : "Expand inner JSON / Java map strings into real objects"}
                                >
                                    <Button
                                        size="small"
                                        variant={jsonParsed ? "contained" : "outlined"}
                                        startIcon={jsonParsed
                                            ? <RefreshIcon fontSize="small"/>
                                            : <DataObjectIcon fontSize="small"/>}
                                        onClick={() => setJsonParsed(!jsonParsed)}
                                        sx={{textTransform: 'none', whiteSpace: 'nowrap', flexShrink: 0}}
                                    >
                                        {jsonParsed ? 'Reset JSON' : 'Parse JSON'}
                                    </Button>
                                </Tooltip>

                                {viewJson && (
                                    <Tooltip title={jsonSearchTerm ? "Copy filtered JSON" : "Copy full JSON"}>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            startIcon={<ContentCopyIcon fontSize="small"/>}
                                            onClick={() => copyToClipboard(JSON.stringify(viewJson, null, 4))}
                                            sx={{textTransform: 'none', whiteSpace: 'nowrap', flexShrink: 0}}
                                        >
                                            Copy JSON
                                        </Button>
                                    </Tooltip>
                                )}
                            </Box>
                        )}

                        {noSearchMatch && (
                            <Typography variant="body2" color="textSecondary" sx={{py: 1}}>
                                No key or value matches "{jsonSearch.trim()}"
                            </Typography>
                        )}

                        {viewJson ? (
                            <ReactJson
                                src={viewJson}
                                name={false}
                                collapsed={false}        // fully expanded
                                /* copy icon on every node -> copies that inner JSON, pretty printed */
                                enableClipboard={(copy) =>
                                    copyToClipboard(
                                        typeof copy.src === 'object' && copy.src !== null
                                            ? JSON.stringify(copy.src, null, 4)
                                            : String(copy.src)
                                    )
                                }
                                displayDataTypes={false}
                                indentWidth={4}          // spacing like pretty-printed JSON
                                displayObjectSize={false}
                                style={{ fontSize: "14px" }}
                                theme="rjv-default"      // clean default theme
                            />
                        ) : (
                            !baseJson && <p>No data Found</p>
                        )}
                    </DialogContent>
                </Dialog>

                <Snackbar
                    open={Boolean(copyStatus)}
                    autoHideDuration={2000}
                    onClose={() => setCopyStatus('')}
                    message={copyStatus}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                />

                {/*message dailog*/}
                <Dialog open={msgdialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                    <DialogTitle sx={{m: 0, p: 2}}>
                        Messages
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseDialog}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </DialogTitle>


                    <DialogContent dividers>
                        {selectedLog ? (
                            Array.isArray(selectedLog.message) && selectedLog.message.length > 0 ? (
                                <Box

                                    sx={{
                                        minHeight: '200px',   // ✅ Minimum height (adjust as needed)
                                        maxHeight: '60vh',    // ✅ Maximum height (viewport-relative)
                                        overflowY: 'auto',    // ✅ Enables scrolling when needed
                                        paddingRight: 1       // ✅ Prevents content behind scrollbar
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 2,
                                        }}
                                    >
                                        {selectedLog.message.map((msg, idx) => (
                                            <Card key={idx} variant="outlined" sx={{ backgroundColor: '#fafafa' }}>
                                                <CardHeader
                                                    title={`${msg.type}`}
                                                    titleTypographyProps={{
                                                        variant: 'body1',
                                                        noWrap: true,
                                                        sx: { fontWeight: 'bold' },
                                                    }}
                                                    sx={{
                                                        backgroundColor: getHeaderColor(msg.type),
                                                        paddingY: 1,
                                                        paddingX: 2,
                                                        color: '#ffffff',
                                                    }}
                                                />
                                                <CardContent>
                                                    {/* Message */}
                                                    <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                                                        <strong>Message:</strong> {formatMessageText(msg.text)}
                                                    </Typography>

                                                    {/* Additional Info */}
                                                    {msg.addInfo && (
                                                        <Typography variant="body2" sx={{ marginTop: 1 }}>
                                                            <strong>Additional Info:</strong> {msg.addInfo}
                                                        </Typography>
                                                    )}

                                                    {/* Exception */}
                                                    {msg.exception && msg.exception !== '' && (
                                                        <Box
                                                            sx={{
                                                                marginTop: 2,
                                                                padding: 1,
                                                                backgroundColor: '#fff0f0',
                                                                borderRadius: 1,
                                                                fontFamily: 'monospace',
                                                                fontSize: '0.85rem',
                                                                whiteSpace: 'pre-wrap',
                                                                wordBreak: 'break-word',
                                                                maxHeight: '300px',
                                                                overflowY: 'auto',
                                                                overflowX: 'auto',
                                                            }}
                                                        >
                                                            <strong>Exception:</strong>
                                                            <br />
                                                            {msg.exception}
                                                        </Box>
                                                    )}
                                                </CardContent>
                                            </Card>
                                        ))}
                                    </Box>
                                </Box>

                            ) : (
                                <Typography variant="body2" color="textSecondary">
                                    No messages to display
                                </Typography>
                            )
                        ) : (
                            <Typography>No data Found</Typography>
                        )}
                    </DialogContent>


                </Dialog>

            </Grid>
        </Box>

    );
};